import SyncableModel from './SyncableModel';
import Cycle from './Cycle';

export default class Fasting extends SyncableModel {
    static name = 'Fasting'

    _fillable = [
      'id',
      'cycle_id', 'logged_date',
      'fasting', 'remark',
      'created_at', 'updated_at', 'synced_at', 'deleted_at'
    ]

    static _parents = ['cycle'];

    static endpoint = '/fastings'

    static allowReplaceUpdate = true

    relationCycle() {
      return Cycle.query().withoutGlobalScope('soft_delete').whereKey(this.cycle_id);
    }
}
